export var indexPrefix  = '@';
export var scalePrefix  = '%';
export var dataPrefix   = ':';
